/**
 * Route for `offer18-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { Offer18IntegrationPage } from "../features/offer18-integration/Offer18IntegrationPage";

export const offer18IntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/offer18-integration",
	component: Offer18IntegrationPage,
});

export default offer18IntegrationRoute;
